/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  width: 100%;
}

.#{$prefix}step-container-wrapper {
  padding: 48px 0px 48px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  @include for-size(tablet) {
    padding: 32px 0px 32px;
  }

  @include for-size(phone) {
    padding: 32px 0px 32px 0px;
  }

  &.#{$prefix}circle {
    .#{$prefix}step-container {
      @include for-size(phone) {
        &:not(.#{$prefix}vertical) {
          display: inline-block;
          margin: 0 30%;
        }
      }

      .#{$prefix}step {
        position: relative;
        display: flex;
        align-items: flex-start;
        min-height: 82px;
        list-style: none;
        margin: 0;
        padding: 0;

        &.#{$prefix}vertical {
          flex-direction: column;
          justify-content: flex-start;
        }
      }
    }
  }

  &.#{$prefix}pictogram {
    .#{$prefix}step {
      position: relative;
      display: flex;
      align-items: flex-start;
      list-style: none;
      margin: 0;
      padding: 0;

      &.#{$prefix}vertical {
        flex-direction: column;
        justify-content: flex-start;
      }

      @include for-size(phone) {
        flex-direction: column;
        justify-content: flex-start;
      }
    }
  }
}
